import { render } from "./RechargeRecord.vue?vue&type=template&id=24b0b7fa&scoped=true"
import script from "./RechargeRecord.vue?vue&type=script&lang=js"
export * from "./RechargeRecord.vue?vue&type=script&lang=js"

import "./RechargeRecord.vue?vue&type=style&index=0&id=24b0b7fa&lang=stylus&scoped=true"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b0b7fa"]])

export default __exports__